import React from 'react';
import { withRouter } from 'react-router-dom';
import './styles.scss';
import LoginForm from '../../forms/LoginForm';

export class Login extends React.Component {
  render() {
    return (
      <div id="page-container" className="row align-items-center justify-content-center">
        <LoginForm />
      </div>
    );
  }
}

export default withRouter(Login);


// WEBPACK FOOTER //
// ./src/components/pages/Login/Login.jsx